import { Outlet, createFileRoute } from '@tanstack/react-router';

import { VStack } from '@/components/Layout';

import { Header } from './-header/-components';

/**
 * 開発チケット 詳細画面の Layout。
 *
 * Value 詳細の `_layout.tsx` と同じパターン。チケットは現状 read-only スコープのため
 * CForm / Zustand store / ValueDetailOutletWithForm 相当のラッパーは持たず、
 * `<Header />` と `<Outlet />` を縦に並べるだけ。
 */
export const Route = createFileRoute(
  '/_stacktrace/development-tickets/$ticketId/_layout',
)({
  component: Layout,
});

function Layout() {
  return (
    <VStack>
      <Header />
      <Outlet />
    </VStack>
  );
}
